<div class="card mb-0">
  <div class="flex justify-between items-start mb-3">
    <div>
      <span class="block text-muted-color font-medium text-sm mb-2">Avg Run Duration</span>
      <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ durationSeconds() | duration }}</div>
    </div>
    <div class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-lg" style="width: 2.25rem; height: 2.25rem">
      <i class="pi pi-clock text-purple-500 text-lg"></i>
    </div>
  </div>
  <div class="flex items-center text-xs">
    <i class="pi pi-chart-line text-purple-500 mr-1"></i>
    <span class="text-muted-color">Average workflow run length</span>
  </div>
</div>
